export default __webpack_public_path__ + "static/media/eye-deactive.fd966dcf.svg";